import React, { useState, useEffect, useRef } from "react";

// Layout/UI
import { Box } from "@metrea-ui/v2";
import styles from "./ChooseOneValue.module.css";
import VerticalSliderInput from "../VerticalSlider/VerticalSliderInput";

// Utilities
import { findObjectByProperty, getRandomInteger } from "src/utils/dataUtils";
import { applyFormatToNumber } from "src/utils/formatUtils";

const ChooseOneValue = (props) => {
	const renderCount = useRef(0);
	renderCount.current++;

	const [thisCfg, setThisCfg] = useState({});
	const [arrayItems, setArrayItems] = useState([]);

	const getArrayItems = (cfg) => {
		let arrayTemp = [];

		for (let idx = 1; idx <= 1; idx++) {
			if (typeof cfg[`comp_value${idx}`] !== "undefined") {
				arrayTemp.push({
					id: idx,
					comp_id: cfg.comp_id,
					value: cfg[`comp_value${idx}`],
				});
			}
		}
		arrayTemp.sort((x, y) => x.value - y.value);
		return arrayTemp;
	};

	useEffect(() => {
		let thisCfg = findObjectByProperty(props.scenarioConfigs, "comp_id", props.extra.id);

		if (!thisCfg) {
			thisCfg = {
				id: getRandomInteger(),
				scenario_id: props.extra.scenario_id,
				comp_type_id: props.pref.id === 601 ? props.extra.type_id : props.pref.id,
				comp_id: props.extra.id,
				comp_value1: "0",
				comp_value2: "0",
				status_id: 1,
				sort_id: 1000,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2023-10-02T12:18:26.433Z",
				updatedAt: "2023-10-02T12:18:26.433Z",
				createdBy: 0,
				updatedBy: 0,
			};
			props.scenarioConfigs.push(thisCfg);
		}

		setThisCfg({ ...thisCfg });
		setArrayItems([...getArrayItems({ ...thisCfg })]);
	}, [props.scenarioConfigs, props.extra, props.pref]);

	const sliderChangeHandler = (items) => {
		items.map((x) => {
			thisCfg[`comp_value${x.id}`] = x.value;
			thisCfg.update_flag = 102;
			return false;
		});
		setThisCfg({ ...thisCfg });

		props.onChange(thisCfg);

		// debugLog(10, "[ChooseOneValue] sliderChangeHandler", {
		// 	items: items,
		// 	arrayItems: arrayItems,
		// 	thisCfg: thisCfg,
		// });
	};

	if (props.label === "FY23") {
		// debugLog(10, "[ChooseOneValue]", { props: props, arrayItems: arrayItems, thisCfg: thisCfg });
	}

	if (thisCfg?.id === 545) {
		// debugLog(10, "[ChooseOneValue] - render", {
		// 	props: props,
		// 	renderCount: renderCount.current,
		// 	thisCfg: thisCfg,
		// 	arrayItems: arrayItems,
		// });
	}

	return (
		<Box minH="280px" w="100%" h="100%" p="0">
			<Box minH="15%" mb="10px">
				<label className={styles.configLabel}>{props.label}</label>
				{props.extra.total_budget_per_year && (
					<label className={styles.baselineValue}>
						Baseline:{" "}
						{applyFormatToNumber(
							props.extra.total_budget_per_year,
							/* props.extra.decimalPoint, */
							0,
							props.extra.currencySymbol,
							props.extra.currencyUnit,
							false,
						)}
					</label>
				)}
			</Box>
			<div
				className={styles.configGroup}
				style={props.range !== "normalized" ? { padding: "0px" } : {}}
			>
				{arrayItems.length > 0 && (
					<VerticalSliderInput
						key={`single-${props.extra.id}`}
						items={arrayItems}
						range={props.range}
						step={props.step}
						mode={props.mode}
						extra={props.extra}
						onChange={sliderChangeHandler}
						onError={props.onError}
					/>
				)}
			</div>
			<Box minH="5%">
				<label className={styles.baselineValue}>
					New Budget:{" "}
					{applyFormatToNumber(
						props.extra.total_budget_per_year * 1 + thisCfg.comp_value1 * 1,
						0,
						props.extra.currencySymbol,
						props.extra.currencyUnit,
					)}
				</label>
			</Box>
		</Box>
	);
};

export default ChooseOneValue;
